export const getOrderData = state => state.registeredVoucherOrder.order;

export const getOrderPage = state => state.registeredVoucherOrder.page;
